<template>
  <span class="icon text-primary">
    <span
      class="loading-indicator"
      :class="{ 'text-white': white }"
    ></span>
  </span>
</template>

<script>
export default {
  name: "InlineSpinner",
  props: {
    white: { default: false, required: false, type: Boolean },
  },
}
</script>

<style scoped></style>
